import Vue from "vue";
import Vuex from "vuex";

import authentication from "./modules/authentication";
import communication from "./modules/communication";
import documents from "./modules/documents";
import candidates from "./modules/candidates";
import employers from "./modules/employers";
import agency from "./modules/agency";
import general from "./modules/general";
import dialogs from "./modules/dialogs";
import dialogContent from "./modules/dialogContent";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // menuState: '',
    skills: [
      "Administration",
      "Advocacy/Public Engagement",
      "Business",
      "Clinical Work",
      "Education & Skills Training",
      "Event Planning",
      "Finance",
      "Fundraising",
      "Grant Development",
      "Human Resources",
      "Information Technology",
      "Knowledge Translation",
      "Monitoring, Evaluation & Research",
      "Partnership Building",
      "Policy",
      "Program Management/Coordination",
      "Project Planning",
      "Public Relations/Communications",
      "Quality Improvement",
      "Stakeholder Engagement",
      "Strategy Development",
      "Supervision"
    ],
    focusAreas: [
      // 'Chronic Diseases',
      "Climate Change",
      "Education",
      "Emergency Response",
      "Environmental Health",
      "Epidemiology",
      "Food Security & Nutrition",
      "Indigenous Health",
      "Infectious Diseases",
      "International Development",
      "Medicine",
      "Mental Health",
      "Migration and Refugee Health",
      "Non-Infectious Diseases",
      "Public Health",
      "Sexual & Reproductive Health",
      "Vision Care",
      "Water & Sanitation",
      "Women’s and/or Children’s Health",
      "Youth Health"
    ],
    jobTypes: [
      "Contract",
      "Fellowship",
      "Full-Time",
      "Internship",
      "Part-Time",
      "Volunteer"
    ],
    organizationTypes: [
      "Charity",
      "For-Profit",
      "Non-Profit/NGO",
      "Hospital",
      "Multilateral Agency",
      "Governmental Organization",
      "University/Research Lab"
    ],
    organizationSizes: [
      "1-10",
      "11-50",
      "51-100",
      "101-200",
      "201-500",
      "500+"
    ],
    organizationStatures: [
      "Well known with an established brand",
      "Smaller, less well known"
    ],
    // https://css-tricks.com/snippets/javascript/array-of-country-names/
    countries: [
      "Afghanistan",
      "Albania",
      "Algeria",
      "Andorra",
      "Angola",
      "Anguilla",
      "Antigua &amp; Barbuda",
      "Argentina",
      "Armenia",
      "Aruba",
      "Australia",
      "Austria",
      "Azerbaijan",
      "Bahamas",
      "Bahrain",
      "Bangladesh",
      "Barbados",
      "Belarus",
      "Belgium",
      "Belize",
      "Benin",
      "Bermuda",
      "Bhutan",
      "Bolivia",
      "Bosnia &amp; Herzegovina",
      "Botswana",
      "Brazil",
      "British Virgin Islands",
      "Brunei",
      "Bulgaria",
      "Burkina Faso",
      "Burundi",
      "Cambodia",
      "Cameroon",
      "Canada",
      "Cape Verde",
      "Cayman Islands",
      "Chad",
      "Chile",
      "China",
      "Colombia",
      "Congo",
      "Cook Islands",
      "Costa Rica",
      "Cote D Ivoire",
      "Croatia",
      "Cruise Ship",
      "Cuba",
      "Cyprus",
      "Czech Republic",
      "Denmark",
      "Djibouti",
      "Dominica",
      "Dominican Republic",
      "Ecuador",
      "Egypt",
      "El Salvador",
      "Equatorial Guinea",
      "Estonia",
      "Ethiopia",
      "Falkland Islands",
      "Faroe Islands",
      "Fiji",
      "Finland",
      "France",
      "French Polynesia",
      "French West Indies",
      "Gabon",
      "Gambia",
      "Georgia",
      "Germany",
      "Ghana",
      "Gibraltar",
      "Greece",
      "Greenland",
      "Grenada",
      "Guam",
      "Guatemala",
      "Guernsey",
      "Guinea",
      "Guinea Bissau",
      "Guyana",
      "Haiti",
      "Honduras",
      "Hong Kong",
      "Hungary",
      "Iceland",
      "India",
      "Indonesia",
      "Iran",
      "Iraq",
      "Ireland",
      "Isle of Man",
      "Israel",
      "Italy",
      "Jamaica",
      "Japan",
      "Jersey",
      "Jordan",
      "Kazakhstan",
      "Kenya",
      "Kuwait",
      "Kyrgyz Republic",
      "Laos",
      "Latvia",
      "Lebanon",
      "Lesotho",
      "Liberia",
      "Libya",
      "Liechtenstein",
      "Lithuania",
      "Luxembourg",
      "Macau",
      "Macedonia",
      "Madagascar",
      "Malawi",
      "Malaysia",
      "Maldives",
      "Mali",
      "Malta",
      "Mauritania",
      "Mauritius",
      "Mexico",
      "Moldova",
      "Monaco",
      "Mongolia",
      "Montenegro",
      "Montserrat",
      "Morocco",
      "Mozambique",
      "Namibia",
      "Nepal",
      "Netherlands",
      "Netherlands Antilles",
      "New Caledonia",
      "New Zealand",
      "Nicaragua",
      "Niger",
      "Nigeria",
      "Norway",
      "Oman",
      "Pakistan",
      "Palestine",
      "Panama",
      "Papua New Guinea",
      "Paraguay",
      "Peru",
      "Philippines",
      "Poland",
      "Portugal",
      "Puerto Rico",
      "Qatar",
      "Reunion",
      "Romania",
      "Russia",
      "Rwanda",
      "Saint Pierre &amp; Miquelon",
      "Samoa",
      "San Marino",
      "Satellite",
      "Saudi Arabia",
      "Senegal",
      "Serbia",
      "Seychelles",
      "Sierra Leone",
      "Singapore",
      "Slovakia",
      "Slovenia",
      "South Africa",
      "South Korea",
      "Spain",
      "Sri Lanka",
      "St Kitts &amp; Nevis",
      "St Lucia",
      "St Vincent",
      "St. Lucia",
      "Sudan",
      "Suriname",
      "Swaziland",
      "Sweden",
      "Switzerland",
      "Syria",
      "Taiwan",
      "Tajikistan",
      "Tanzania",
      "Thailand",
      "Timor L'Este",
      "Togo",
      "Tonga",
      "Trinidad &amp; Tobago",
      "Tunisia",
      "Turkey",
      "Turkmenistan",
      "Turks &amp; Caicos",
      "Uganda",
      "Ukraine",
      "United Arab Emirates",
      "United Kingdom",
      "United States",
      "Uruguay",
      "Uzbekistan",
      "Venezuela",
      "Vietnam",
      "Virgin Islands (US)",
      "Yemen",
      "Zambia",
      "Zimbabwe"
    ],
    // countries: [
    //   {"name": "Afghanistan", "code": "AF"},
    //   {"name": "land Islands", "code": "AX"},
    //   {"name": "Albania", "code": "AL"},
    //   {"name": "Algeria", "code": "DZ"},
    //   {"name": "American Samoa", "code": "AS"},
    //   {"name": "AndorrA", "code": "AD"},
    //   {"name": "Angola", "code": "AO"},
    //   {"name": "Anguilla", "code": "AI"},
    //   {"name": "Antarctica", "code": "AQ"},
    //   {"name": "Antigua and Barbuda", "code": "AG"},
    //   {"name": "Argentina", "code": "AR"},
    //   {"name": "Armenia", "code": "AM"},
    //   {"name": "Aruba", "code": "AW"},
    //   {"name": "Australia", "code": "AU"},
    //   {"name": "Austria", "code": "AT"},
    //   {"name": "Azerbaijan", "code": "AZ"},
    //   {"name": "Bahamas", "code": "BS"},
    //   {"name": "Bahrain", "code": "BH"},
    //   {"name": "Bangladesh", "code": "BD"},
    //   {"name": "Barbados", "code": "BB"},
    //   {"name": "Belarus", "code": "BY"},
    //   {"name": "Belgium", "code": "BE"},
    //   {"name": "Belize", "code": "BZ"},
    //   {"name": "Benin", "code": "BJ"},
    //   {"name": "Bermuda", "code": "BM"},
    //   {"name": "Bhutan", "code": "BT"},
    //   {"name": "Bolivia", "code": "BO"},
    //   {"name": "Bosnia and Herzegovina", "code": "BA"},
    //   {"name": "Botswana", "code": "BW"},
    //   {"name": "Bouvet Island", "code": "BV"},
    //   {"name": "Brazil", "code": "BR"},
    //   {"name": "British Indian Ocean Territory", "code": "IO"},
    //   {"name": "Brunei Darussalam", "code": "BN"},
    //   {"name": "Bulgaria", "code": "BG"},
    //   {"name": "Burkina Faso", "code": "BF"},
    //   {"name": "Burundi", "code": "BI"},
    //   {"name": "Cambodia", "code": "KH"},
    //   {"name": "Cameroon", "code": "CM"},
    //   {"name": "Canada", "code": "CA"},
    //   {"name": "Cape Verde", "code": "CV"},
    //   {"name": "Cayman Islands", "code": "KY"},
    //   {"name": "Central African Republic", "code": "CF"},
    //   {"name": "Chad", "code": "TD"},
    //   {"name": "Chile", "code": "CL"},
    //   {"name": "China", "code": "CN"},
    //   {"name": "Christmas Island", "code": "CX"},
    //   {"name": "Cocos (Keeling) Islands", "code": "CC"},
    //   {"name": "Colombia", "code": "CO"},
    //   {"name": "Comoros", "code": "KM"},
    //   {"name": "Congo", "code": "CG"},
    //   {"name": "Congo, The Democratic Republic of the", "code": "CD"},
    //   {"name": "Cook Islands", "code": "CK"},
    //   {"name": "Costa Rica", "code": "CR"},
    //   {"name": "Cote D"Ivoire", "code": "CI"},
    //   {"name": "Croatia", "code": "HR"},
    //   {"name": "Cuba", "code": "CU"},
    //   {"name": "Cyprus", "code": "CY"},
    //   {"name": "Czech Republic", "code": "CZ"},
    //   {"name": "Denmark", "code": "DK"},
    //   {"name": "Djibouti", "code": "DJ"},
    //   {"name": "Dominica", "code": "DM"},
    //   {"name": "Dominican Republic", "code": "DO"},
    //   {"name": "Ecuador", "code": "EC"},
    //   {"name": "Egypt", "code": "EG"},
    //   {"name": "El Salvador", "code": "SV"},
    //   {"name": "Equatorial Guinea", "code": "GQ"},
    //   {"name": "Eritrea", "code": "ER"},
    //   {"name": "Estonia", "code": "EE"},
    //   {"name": "Ethiopia", "code": "ET"},
    //   {"name": "Falkland Islands (Malvinas)", "code": "FK"},
    //   {"name": "Faroe Islands", "code": "FO"},
    //   {"name": "Fiji", "code": "FJ"},
    //   {"name": "Finland", "code": "FI"},
    //   {"name": "France", "code": "FR"},
    //   {"name": "French Guiana", "code": "GF"},
    //   {"name": "French Polynesia", "code": "PF"},
    //   {"name": "French Southern Territories", "code": "TF"},
    //   {"name": "Gabon", "code": "GA"},
    //   {"name": "Gambia", "code": "GM"},
    //   {"name": "Georgia", "code": "GE"},
    //   {"name": "Germany", "code": "DE"},
    //   {"name": "Ghana", "code": "GH"},
    //   {"name": "Gibraltar", "code": "GI"},
    //   {"name": "Greece", "code": "GR"},
    //   {"name": "Greenland", "code": "GL"},
    //   {"name": "Grenada", "code": "GD"},
    //   {"name": "Guadeloupe", "code": "GP"},
    //   {"name": "Guam", "code": "GU"},
    //   {"name": "Guatemala", "code": "GT"},
    //   {"name": "Guernsey", "code": "GG"},
    //   {"name": "Guinea", "code": "GN"},
    //   {"name": "Guinea-Bissau", "code": "GW"},
    //   {"name": "Guyana", "code": "GY"},
    //   {"name": "Haiti", "code": "HT"},
    //   {"name": "Heard Island and Mcdonald Islands", "code": "HM"},
    //   {"name": "Holy See (Vatican City State)", "code": "VA"},
    //   {"name": "Honduras", "code": "HN"},
    //   {"name": "Hong Kong", "code": "HK"},
    //   {"name": "Hungary", "code": "HU"},
    //   {"name": "Iceland", "code": "IS"},
    //   {"name": "India", "code": "IN"},
    //   {"name": "Indonesia", "code": "ID"},
    //   {"name": "Iran, Islamic Republic Of", "code": "IR"},
    //   {"name": "Iraq", "code": "IQ"},
    //   {"name": "Ireland", "code": "IE"},
    //   {"name": "Isle of Man", "code": "IM"},
    //   {"name": "Israel", "code": "IL"},
    //   {"name": "Italy", "code": "IT"},
    //   {"name": "Jamaica", "code": "JM"},
    //   {"name": "Japan", "code": "JP"},
    //   {"name": "Jersey", "code": "JE"},
    //   {"name": "Jordan", "code": "JO"},
    //   {"name": "Kazakhstan", "code": "KZ"},
    //   {"name": "Kenya", "code": "KE"},
    //   {"name": "Kiribati", "code": "KI"},
    //   {"name": "Korea, Democratic People"S Republic of", "code": "KP"},
    //   {"name": "Korea, Republic of", "code": "KR"},
    //   {"name": "Kuwait", "code": "KW"},
    //   {"name": "Kyrgyzstan", "code": "KG"},
    //   {"name": "Lao People"S Democratic Republic", "code": "LA"},
    //   {"name": "Latvia", "code": "LV"},
    //   {"name": "Lebanon", "code": "LB"},
    //   {"name": "Lesotho", "code": "LS"},
    //   {"name": "Liberia", "code": "LR"},
    //   {"name": "Libyan Arab Jamahiriya", "code": "LY"},
    //   {"name": "Liechtenstein", "code": "LI"},
    //   {"name": "Lithuania", "code": "LT"},
    //   {"name": "Luxembourg", "code": "LU"},
    //   {"name": "Macao", "code": "MO"},
    //   {"name": "Macedonia, The Former Yugoslav Republic of", "code": "MK"},
    //   {"name": "Madagascar", "code": "MG"},
    //   {"name": "Malawi", "code": "MW"},
    //   {"name": "Malaysia", "code": "MY"},
    //   {"name": "Maldives", "code": "MV"},
    //   {"name": "Mali", "code": "ML"},
    //   {"name": "Malta", "code": "MT"},
    //   {"name": "Marshall Islands", "code": "MH"},
    //   {"name": "Martinique", "code": "MQ"},
    //   {"name": "Mauritania", "code": "MR"},
    //   {"name": "Mauritius", "code": "MU"},
    //   {"name": "Mayotte", "code": "YT"},
    //   {"name": "Mexico", "code": "MX"},
    //   {"name": "Micronesia, Federated States of", "code": "FM"},
    //   {"name": "Moldova, Republic of", "code": "MD"},
    //   {"name": "Monaco", "code": "MC"},
    //   {"name": "Mongolia", "code": "MN"},
    //   {"name": "Montenegro", "code": "ME"},
    //   {"name": "Montserrat", "code": "MS"},
    //   {"name": "Morocco", "code": "MA"},
    //   {"name": "Mozambique", "code": "MZ"},
    //   {"name": "Myanmar", "code": "MM"},
    //   {"name": "Namibia", "code": "NA"},
    //   {"name": "Nauru", "code": "NR"},
    //   {"name": "Nepal", "code": "NP"},
    //   {"name": "Netherlands", "code": "NL"},
    //   {"name": "Netherlands Antilles", "code": "AN"},
    //   {"name": "New Caledonia", "code": "NC"},
    //   {"name": "New Zealand", "code": "NZ"},
    //   {"name": "Nicaragua", "code": "NI"},
    //   {"name": "Niger", "code": "NE"},
    //   {"name": "Nigeria", "code": "NG"},
    //   {"name": "Niue", "code": "NU"},
    //   {"name": "Norfolk Island", "code": "NF"},
    //   {"name": "Northern Mariana Islands", "code": "MP"},
    //   {"name": "Norway", "code": "NO"},
    //   {"name": "Oman", "code": "OM"},
    //   {"name": "Pakistan", "code": "PK"},
    //   {"name": "Palau", "code": "PW"},
    //   {"name": "Palestinian Territory, Occupied", "code": "PS"},
    //   {"name": "Panama", "code": "PA"},
    //   {"name": "Papua New Guinea", "code": "PG"},
    //   {"name": "Paraguay", "code": "PY"},
    //   {"name": "Peru", "code": "PE"},
    //   {"name": "Philippines", "code": "PH"},
    //   {"name": "Pitcairn", "code": "PN"},
    //   {"name": "Poland", "code": "PL"},
    //   {"name": "Portugal", "code": "PT"},
    //   {"name": "Puerto Rico", "code": "PR"},
    //   {"name": "Qatar", "code": "QA"},
    //   {"name": "Reunion", "code": "RE"},
    //   {"name": "Romania", "code": "RO"},
    //   {"name": "Russian Federation", "code": "RU"},
    //   {"name": "RWANDA", "code": "RW"},
    //   {"name": "Saint Helena", "code": "SH"},
    //   {"name": "Saint Kitts and Nevis", "code": "KN"},
    //   {"name": "Saint Lucia", "code": "LC"},
    //   {"name": "Saint Pierre and Miquelon", "code": "PM"},
    //   {"name": "Saint Vincent and the Grenadines", "code": "VC"},
    //   {"name": "Samoa", "code": "WS"},
    //   {"name": "San Marino", "code": "SM"},
    //   {"name": "Sao Tome and Principe", "code": "ST"},
    //   {"name": "Saudi Arabia", "code": "SA"},
    //   {"name": "Senegal", "code": "SN"},
    //   {"name": "Serbia", "code": "RS"},
    //   {"name": "Seychelles", "code": "SC"},
    //   {"name": "Sierra Leone", "code": "SL"},
    //   {"name": "Singapore", "code": "SG"},
    //   {"name": "Slovakia", "code": "SK"},
    //   {"name": "Slovenia", "code": "SI"},
    //   {"name": "Solomon Islands", "code": "SB"},
    //   {"name": "Somalia", "code": "SO"},
    //   {"name": "South Africa", "code": "ZA"},
    //   {"name": "South Georgia and the South Sandwich Islands", "code": "GS"},
    //   {"name": "Spain", "code": "ES"},
    //   {"name": "Sri Lanka", "code": "LK"},
    //   {"name": "Sudan", "code": "SD"},
    //   {"name": "Suriname", "code": "SR"},
    //   {"name": "Svalbard and Jan Mayen", "code": "SJ"},
    //   {"name": "Swaziland", "code": "SZ"},
    //   {"name": "Sweden", "code": "SE"},
    //   {"name": "Switzerland", "code": "CH"},
    //   {"name": "Syrian Arab Republic", "code": "SY"},
    //   {"name": "Taiwan, Province of China", "code": "TW"},
    //   {"name": "Tajikistan", "code": "TJ"},
    //   {"name": "Tanzania, United Republic of", "code": "TZ"},
    //   {"name": "Thailand", "code": "TH"},
    //   {"name": "Timor-Leste", "code": "TL"},
    //   {"name": "Togo", "code": "TG"},
    //   {"name": "Tokelau", "code": "TK"},
    //   {"name": "Tonga", "code": "TO"},
    //   {"name": "Trinidad and Tobago", "code": "TT"},
    //   {"name": "Tunisia", "code": "TN"},
    //   {"name": "Turkey", "code": "TR"},
    //   {"name": "Turkmenistan", "code": "TM"},
    //   {"name": "Turks and Caicos Islands", "code": "TC"},
    //   {"name": "Tuvalu", "code": "TV"},
    //   {"name": "Uganda", "code": "UG"},
    //   {"name": "Ukraine", "code": "UA"},
    //   {"name": "United Arab Emirates", "code": "AE"},
    //   {"name": "United Kingdom", "code": "GB"},
    //   {"name": "United States", "code": "US"},
    //   {"name": "United States Minor Outlying Islands", "code": "UM"},
    //   {"name": "Uruguay", "code": "UY"},
    //   {"name": "Uzbekistan", "code": "UZ"},
    //   {"name": "Vanuatu", "code": "VU"},
    //   {"name": "Venezuela", "code": "VE"},
    //   {"name": "Viet Nam", "code": "VN"},
    //   {"name": "Virgin Islands, British", "code": "VG"},
    //   {"name": "Virgin Islands, U.S.", "code": "VI"},
    //   {"name": "Wallis and Futuna", "code": "WF"},
    //   {"name": "Western Sahara", "code": "EH"},
    //   {"name": "Yemen", "code": "YE"},
    //   {"name": "Zambia", "code": "ZM"},
    //   {"name": "Zimbabwe", "code": "ZW"}
    // ],
    compensationTypes: ["per hour", "per year"],
    salaryRanges: [
      "$0 (i.e. volunteer)",
      "$1-15,000",
      "$15,001-30,000",
      "$30,001-45,000",
      "$45,001-60,000",
      "$60,001-75,000",
      "$75,000-100,000",
      "$100,001-150,000",
      "$150,001+"
    ],
    values: [
      // 'Person-centred',
      // 'Commitment to Sustainability',
      // 'Commitment to Sustainability',
      // 'Collaboration / Partnership',
      // 'Accountability',
      // 'Transparency',
      // 'Integrity',
      // 'Learning',
      // 'Innovation',
      // 'Inclusiveness/Diversity',
      // 'Evidence-based Research',
      // 'Humility',
      // 'Mentorship',
      // 'Efficiency',
      // 'Neutrality & Non-judgement',
      // 'Religious',
      "Equity",
      "Transparency",
      "Integrity",
      "Collaboration",
      "Sustainability",
      "Innovation",
      "Accountability",
      "Humility",
      "Mentorship",
      "Efficiency",
      "Evidence-based work"
    ],
    qualities: [
      // 'Passionate',
      // 'Alignment with Organization',
      // 'Competency',
      // 'Team Player',
      // 'Interpersonal Skills',
      // 'Adaptability',
      // 'Flexibility',
      // 'Open-minded',
      // 'Enthusiasm',
      // 'Autonomous & Self-motivated',
      // 'Accountable',
      // 'Reliable',
      // 'Experience Working Internationally',
      // 'Able to work Internationally',
      // 'Communication Skills',
      // 'Solution-oriented',
      // 'Creative & Innovative',
      // 'Leadership',
      // 'Integrity',
      // 'Detail-oriented',
      // 'Respect',
      // 'Professionalism',
      // 'Emotional Intelligence',
      // 'Organized',
      // 'Resourceful',
      "Competency",
      "Alignment with organization (values, mission, etc.)",
      "Passion",
      "Interpersonal skills",
      "Adaptability",
      "Open-minded",
      "Enthusiastic",
      "Team player",
      "Self-motivated",
      "Accountable",
      "Reliable",
      "Experience working internationally",
      "Communication skills (oral and/or written)",
      "Solution-oriented",
      "Creative / innovative",
      "Integrity",
      "Detail-oriented",
      "Respect",
      "Professionalism",
      "Emotional intelligence",
      "Organized",
      "Resourceful"
    ],
    perks: [
      "Networking Opportunities",
      "Professional Development Opportunities",
      "Remote Work Options",
      "Flexible Schedule",
      // 'Conference Cost Coverage',
      "Travel Opportunities",
      "Travel Expense Coverage",
      // 'Accommodation Provided',
      // 'Monthly Living Allowance',
      "Health Benefits/Insurance",
      "Paid Vacation",
      "Pension Plan",
      // 'Vaccination Coverage',
      // 'Travel Opportunities',
      // 'Inclusive Workplace',
      // 'Diversity in Hiring',
      // 'Supportive Work Team',
      "Sick Leave",
      "Parental Leave"
    ],
    blogCategories: [
      "Career Advice",
      "Global Health Recent News",
      // 'Opportunities, Grants, Prizes and More',
      "Webinar Series"
    ],
    eventTypes: ["Conference", "Webinar", "In-person Seminar/Gathering"],

    statusOptions: ["New", "Personal Information", "Profile Complete"],
    // candidateStatuses: [
    //   'Applied', 'Interview Booked', 'Interview Complete', 'Accepted', 'Rejected', 'Background Check Complete', 'Reference Check Complete', 'Hired',
    // ],
    // employerStatuses: [
    //   'Applied', 'Welcome Call Complete', 'Application Approved', 'Package Selected', 'Payment Info Entered', 'Consultation Booked', 'Consultation Complete', 'Nanny Assigned',
    //   'Documents Signed', 'Active', 'Placement Fee Paid', 'Inactive',
    // ],
    candidateEmployerRelationshipStatuses: [
      "Under Consideration",
      "Interested",
      "Not Interested",
      "Offer Extended",
      "Assigned"
    ],
    jobStatuses: ["Requested", "Pending", "Approved", "Completed"],
    ages: [
      "Newborn (0-6 months)",
      "Infant (6 months - 12 months)",
      "Toddler (1-2 years)",
      "Preschool (3-5 years)",
      "Gradeschool (6-12 years)",
      "Teenager (13+ years)"
    ],
    experiences: [
      "Private Babysitting (non-relatives)",
      "Private Babysitting (only-relatives)",
      "Daycare Center",
      "Preschool",
      "Church Nursery",
      "Camp Counsellor",
      "Nanny"
    ],
    comfortableWith: [
      "Drive/Transport children to/from activities",
      "Overnight Care",
      "Animals",
      "Parents who work from home",
      "Supervising Swimming",
      "Light housekeeping",
      "Caring for sick children",
      "Meal prepping",
      "Running light errands"
    ],
    documentsOptions: [
      "Child Abuse Check",
      "Criminal Record Check with Vulnerable Sector Check",
      "Standard CPR/First Aid Level C",
      "Drivers Abstract Report"
    ],
    days: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    referrer: [
      "Google",
      "Social Media",
      "Fox 8 News",
      "NEO Parenting Magazine"
    ],
    // commitmentOptions: [
    //   'Long Term (longer than 1 year)', 'Short Term (1 year or less)', 'Temporary',
    // ],
    // availabilityOptions: [
    //   'Full Time', 'Part Time', 'Come and Go', 'Live In'
    // ],
    // drvingStatuses: [
    //   'D.L. and Car', 'Driver\'s License only', 'Neither',
    // ],
    // certificationStatuses: [
    //   'Yes', 'Willing to get certified', 'No',
    // ],
    // vaccinationStatuses: [
    //   'Yes', 'Willing to get', 'No'
    // ],
    // petsOptions: [
    //   'Dog', 'Cat', 'Neither',
    // ],
    // travelOptions: [
    //   'Domestic', 'International', 'No travel',
    // ],
    yesNoOptions: ["Yes", "No"],
    // website: 'https://www.tinytreasuresnyc.com/',
    logo: "ttnyc-logo.jpg",
    logoHeight: 90,
    acceptedImageTypes: ["image/jpeg", "image/png"],
    acceptResumeType: [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ]
  },
  mutations: {
    // storeMenuState (state, menuState) {
    //   state.menuState = menuState
    // }
  },
  actions: {
    // setMenuState ({commit}, menuState) {
    //   commit(storeMenuState, menuState)
    // }
  },
  getters: {
    // menuState (state) {
    //   return state.menuState
    // },
    skills(state) {
      return state.skills;
    },
    focusAreas(state) {
      return state.focusAreas;
    },
    jobTypes(state) {
      return state.jobTypes;
    },
    organizationTypes(state) {
      return state.organizationTypes;
    },
    organizationSizes(state) {
      return state.organizationSizes;
    },
    organizationStatures(state) {
      return state.organizationStatures;
    },
    countries(state) {
      return state.countries;
    },
    compensationTypes(state) {
      return state.compensationTypes;
    },
    salaryRanges(state) {
      return state.salaryRanges;
    },
    values(state) {
      return state.values;
    },
    qualities(state) {
      return state.qualities;
    },
    perks(state) {
      return state.perks;
    },
    blogCategories(state) {
      return state.blogCategories;
    },
    eventTypes(state) {
      return state.eventTypes;
    },

    statusOptions(state) {
      return state.statusOptions;
    },

    // candidateStatuses (state) {
    //   return state.candidateStatuses
    // },
    // employerStatuses (state) {
    //   return state.employerStatuses
    // },
    jobStatuses(state) {
      return state.jobStatuses;
    },
    ages(state) {
      return state.ages;
    },
    experiences(state) {
      return state.experiences;
    },
    comfortableWith(state) {
      return state.comfortableWith;
    },
    documentsOptions(state) {
      return state.documentsOptions;
    },
    days(state) {
      return state.days;
    },
    candidateEmployerRelationshipStatuses(state) {
      return state.candidateEmployerRelationshipStatuses;
    },
    yesNoOptions(state) {
      return state.yesNoOptions;
    },
    referrer(state) {
      return state.referrer;
    },
    // website(state) {
    //   return state.website;
    // },
    logo(state) {
      return state.logo;
    },
    logoHeight(state) {
      return state.logoHeight;
    },
    acceptedImageTypes(state) {
      return state.acceptedImageTypes;
    },
    acceptResumeType(state) {
      return state.acceptResumeType;
    }
  },
  modules: {
    authentication,
    communication,
    documents,
    candidates,
    employers,
    agency,
    general,
    dialogs,
    dialogContent
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js